module.exports = __webpack_public_path__ + "static/media/matic.177a2a0e.svg";